import React from "react";
import { styled } from "@mui/material/styles";
import { useAuth0 } from "@auth0/auth0-react";
import {
  AppBar as MuiAppBar,
  Button,
  Toolbar as MuiToolbar,
  Typography,
  Box,
  ButtonBase,
} from "@mui/material";
import { APP_DETAILS, APP_THEME, ROUTES } from "../../../constants";
import useBreakpoints from "../../../hooks/useBreakpoints";
import UserDropdown from "../../../components/UserDropdown";
import { useHistory } from "react-router-dom";
import { Brand, BrandIcon } from "../../../components/Sidebar";

const drawerWidth = APP_THEME.LAYOUT.SIDEBAR_WIDTH;

// Styled Components
const AppBar = styled(MuiAppBar)(({ theme }) => ({
  background: theme.header.background,
  color: theme.header.color,
}));

const Toolbar = styled(MuiToolbar)(({ theme }) => ({
  [theme.breakpoints.up("md")]: {
    minHeight: 96,
  },
  [theme.breakpoints.down("sm")]: {
    minHeight: 64,
  },
}));

const Title = styled(Typography)(({ theme }) => ({
  color: theme.sidebar.header.color || "inherit",
}));

function AppBarComponent() {
  const { loginWithRedirect, isAuthenticated } = useAuth0();
  const history = useHistory();
  const { isXs, isSm, isUpMd } = useBreakpoints();

  const handleButtonClick = () => {
    if (isAuthenticated) {
      history.push(ROUTES.MAP);
    } else {
      loginWithRedirect({ appState: { returnTo: ROUTES.MAP } });
    }
  };

  return (
    <>
      <AppBar position="fixed" elevation={0}>
        <Toolbar>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            width="100%"
          >
            <Box display="flex" alignItems="center">
              <ButtonBase
                component="a"
                href={APP_DETAILS.URL}
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  pointerEvents: "all",
                }}
              >
                <Brand sx={{ width: isUpMd ? drawerWidth : "100%" }}>
                  <BrandIcon
                    src={
                      isUpMd
                        ? APP_DETAILS.ICONS.LOGO_FULL_WHITE
                        : APP_DETAILS.ICONS.LOGO_SIMPLE_WHITE
                    }
                    height="48"
                    alt={APP_DETAILS.SHORT_NAME}
                  />
                </Brand>
              </ButtonBase>
              <Title ml={2} variant={isUpMd ? "h3" : "h4"} noWrap>
                Nitrate Risk Assessment Tool
              </Title>
            </Box>
            <Box display="flex" alignItems="center" gap={3}>
              <Button
                sx={{ mr: 1 }}
                size={isXs ? "small" : isSm ? "medium" : "large"}
                color="secondary"
                variant="contained"
                onClick={handleButtonClick}
              >
                {isAuthenticated
                  ? isXs
                    ? "Dashboard"
                    : "View Dashboard"
                  : isXs
                  ? "Log in"
                  : "Log in to Dashboard"}
              </Button>
              {isAuthenticated && <UserDropdown />}
            </Box>
          </Box>
        </Toolbar>
      </AppBar>
      <Toolbar /> {/* Spacer Toolbar */}
    </>
  );
}

export default AppBarComponent;
